<div class="available-funds-summary-page">
    <lsq-banner
        [titleText]="title"
        [hasContent]="true"
        [reportName]="title"
        [service]="reportService"
        [analyticsName]="analyticsName"
        [subTitle]="lastUpdatedDate | lastUpdatedDate"
        [background]="color.White"
        [datePickerConfiguration]="datePickerConfiguration"
    >
    </lsq-banner>

    <div class="container-fluid page-container">
        <div class="row">
            <div class="col-lg-6 available-funds-section">
                <div class="card">
                    <div class="card-header">
                        Available Funds
                    </div>
                    <div class="card-body">
                        <ng-container *ngIf="availableFundsDataSource.error$ | async">
                            <div class="card-error">
                                <p>{{ dataSourceErrorCopy }}</p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="!(availableFundsDataSource.error$ | async)">
                            <ng-container *ngIf="isLoading">
                                <lsq-circle-loader></lsq-circle-loader>
                            </ng-container>

                            <ng-container *ngIf="!isLoading && (availableFundsData$ | async)">
                                <available-funds-summary-expandable-container
                                    [primaryTotal]="(availableFundsData$ | async).grossAvailable"
                                    text="Gross Available"
                                    [isExpanded]="false"
                                >
                                    <div class="section-indent">
                                        <available-funds-summary-row
                                            text="Unpaid Invoices"
                                            popoverText="The sum total of your purchased AR including both Eligible and Ineligible Invoices."
                                            [primaryValue]="(availableFundsData$ | async).arBalance"
                                            [secondaryValue]="
                                                (availableFundsData$ | async).arBalance
                                            "
                                        >
                                        </available-funds-summary-row>
                                        <available-funds-summary-row
                                            text="Ineligible Invoices"
                                            popoverText="Invoices that LSQ will not fund against. An invoice may become ineligible because it is: missing verification, past due, over credit limit, in dispute, etc."
                                            [signIcon]="icons.MinusSign"
                                            [primaryValue]="
                                                (availableFundsData$ | async).ineligibleBalance
                                            "
                                            [secondaryValue]="
                                                (availableFundsData$ | async)
                                                    .ineligibleBalanceSubtotal
                                            "
                                        >
                                        </available-funds-summary-row>
                                        <available-funds-summary-row
                                            text="Eligible Invoices"
                                            popoverText="Invoices that LSQ will fund."
                                            [signIcon]="icons.EqualSign"
                                            [primaryValue]="
                                                (availableFundsData$ | async).eligibleAr
                                            "
                                        >
                                        </available-funds-summary-row>
                                        <available-funds-summary-row
                                            text="Advance Rate"
                                            popoverText="The percentage of the invoice that LSQ will advance on your Eligible Invoices."
                                            [primaryValue]="
                                                (availableFundsData$ | async).advanceRate / 100
                                            "
                                            [secondaryValue]="
                                                (availableFundsData$ | async).advanceRateSubtotal
                                            "
                                            [isPercent]="true"
                                        >
                                        </available-funds-summary-row>
                                    </div>
                                </available-funds-summary-expandable-container>

                                <available-funds-summary-expandable-container
                                    [primaryTotal]="(availableFundsData$ | async).totalFees"
                                    text="Fees"
                                    [signIcon]="icons.MinusSign"
                                    [isExpanded]="false"
                                >
                                    <div class="section-indent">
                                        <available-funds-summary-row
                                            text="Accrued Collection Fees"
                                            popoverText="Collection Fees are the amount you pay for LSQ to track, collect, process and manage invoices and customer payments and are accrued on a daily basis."
                                            [primaryValue]="
                                                (availableFundsData$ | async).accruedCollectionFees
                                            "
                                            [secondaryValue]="
                                                (availableFundsData$ | async)
                                                    .accruedCollectionFeesSubtotal
                                            "
                                        >
                                        </available-funds-summary-row>
                                        <available-funds-summary-row
                                            text="Accrued Funds Usage Daily Fee"
                                            popoverText="Fees incurred, month to date, based on your Funds Outstanding balance."
                                            [signIcon]="icons.Add"
                                            [primaryValue]="
                                                (availableFundsData$ | async).accruedInterestMtd
                                            "
                                            [secondaryValue]="
                                                (availableFundsData$ | async)
                                                    .accruedInterestMtdSubtotal
                                            "
                                        >
                                        </available-funds-summary-row>
                                    </div>
                                </available-funds-summary-expandable-container>

                                <available-funds-summary-row
                                    [isTotalRow]="true"
                                    text="Funds Outstanding"
                                    popoverText="The outstanding balance of funds that LSQ has advanced to your account."
                                    [signIcon]="icons.MinusSign"
                                    [primaryValue]="(availableFundsData$ | async).fundsOutstanding"
                                >
                                </available-funds-summary-row>

                                <available-funds-summary-row
                                    *ngIf="(availableFundsData$ | async).inventoryAvailability"
                                    [isTotalRow]="true"
                                    text="Inventory Availability"
                                    [signIcon]="icons.Add"
                                    popoverText="The amount added to your Available Funds balance based on your inventory account."
                                    [primaryValue]="
                                        (availableFundsData$ | async).inventoryAvailability
                                    "
                                >
                                </available-funds-summary-row>

                                <available-funds-summary-row
                                    [isTotalRow]="true"
                                    [primaryValue]="(availableFundsData$ | async).availability"
                                    text="Available Funds"
                                    [signIcon]="icons.EqualSign"
                                    popoverText="The total amount of money available in your LSQ account. You can transfer these funds into your company bank account at any time."
                                >
                                </available-funds-summary-row>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
                <available-funds-summary-row
                    [isTotalRow]="true"
                    [primaryValue]="this.totalPendingAmount"
                    text="Pending Funds Request"
                    popoverText="The amount of funds that have been requested but not yet processed."
                >
                </available-funds-summary-row>
            </div>

            <div class="col-lg-6 available-funds-section">
                <div class="card">
                    <div class="card-header">
                        Funds Outstanding Balance
                    </div>

                    <div class="card-body">
                        <ng-container *ngIf="fundsOutstandingBalanceDataSource.error$ | async">
                            <div class="card-error">
                                <p>{{ dataSourceErrorCopy }}</p>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="!(fundsOutstandingBalanceDataSource.error$ | async)">
                            <ng-container *ngIf="isLoading">
                                <lsq-circle-loader></lsq-circle-loader>
                            </ng-container>

                            <ng-container
                                *ngIf="!isLoading && (fundsOutstandingBalanceData$ | async)"
                            >
                                <available-funds-summary-expandable-container
                                    [primaryTotal]="
                                        (fundsOutstandingBalanceData$ | async).arBalance
                                    "
                                    text="Unpaid Invoices"
                                    popoverText="The sum total of your purchased AR including both Eligible and Ineligible Invoices."
                                    [isExpanded]="false"
                                >
                                    <div class="section-indent">
                                        <available-funds-summary-row
                                            text="Beginning Balance"
                                            popoverText="The sum total of your AR including Ineligible Invoices at the start of the month."
                                            [primaryValue]="
                                                (fundsOutstandingBalanceData$ | async).beginningAr
                                            "
                                            [secondaryValue]="
                                                (fundsOutstandingBalanceData$ | async).beginningAr
                                            "
                                        >
                                        </available-funds-summary-row>
                                        <available-funds-summary-row
                                            text="Purchases"
                                            popoverText="The total dollar amount of invoices that LSQ has purchased."
                                            [signIcon]="icons.Add"
                                            [primaryValue]="
                                                (fundsOutstandingBalanceData$ | async).purchases
                                            "
                                            [secondaryValue]="
                                                (fundsOutstandingBalanceData$ | async)
                                                    .purchasesSubtotal
                                            "
                                        >
                                        </available-funds-summary-row>
                                        <available-funds-summary-row
                                            text="Collections"
                                            popoverText="Invoice payments that LSQ has received from your customers."
                                            [signIcon]="icons.MinusSign"
                                            [primaryValue]="
                                                (fundsOutstandingBalanceData$ | async).collections
                                            "
                                            [secondaryValue]="
                                                (fundsOutstandingBalanceData$ | async)
                                                    .collectionsSubtotal
                                            "
                                        >
                                        </available-funds-summary-row>
                                        <available-funds-summary-row
                                            text="Chargebacks"
                                            popoverText='Invoices that have been removed from LSQ’s unpaid invoices without receipt of a payment. Commonly, invoices are "charged back" due to: non-payment, a dispute by your customer, or partial payments.'
                                            [signIcon]="icons.MinusSign"
                                            [primaryValue]="
                                                (fundsOutstandingBalanceData$ | async)
                                                    .chargeBackAmount
                                            "
                                            [secondaryValue]="
                                                (fundsOutstandingBalanceData$ | async)
                                                    .chargeBackAmountSubtotal
                                            "
                                        >
                                        </available-funds-summary-row>
                                        <available-funds-summary-row
                                            text="Non-factored"
                                            popoverText="Payments received from your customer for invoices that were not purchased by LSQ. These payments will be added to your Available Funds."
                                            [signIcon]="icons.Add"
                                            [primaryValue]="
                                                (fundsOutstandingBalanceData$ | async)
                                                    .nonFactoredAmount
                                            "
                                            [secondaryValue]="
                                                (fundsOutstandingBalanceData$ | async)
                                                    .nonFactoredAmountSubtotal
                                            "
                                        >
                                        </available-funds-summary-row>
                                    </div>
                                </available-funds-summary-expandable-container>

                                <available-funds-summary-expandable-container
                                    [primaryTotal]="(fundsOutstandingBalanceData$ | async).reserves"
                                    text="Total Reserves"
                                    [signIcon]="icons.MinusSign"
                                    [isExpanded]="false"
                                >
                                    <div class="section-indent">
                                        <available-funds-summary-row
                                            text="Available Funds"
                                            popoverText="The total amount of money available in your LSQ account. You can transfer these funds into your company bank account at any time."
                                            [primaryValue]="
                                                (fundsOutstandingBalanceData$ | async).availability
                                            "
                                            [secondaryValue]="
                                                (fundsOutstandingBalanceData$ | async).availability
                                            "
                                        >
                                        </available-funds-summary-row>
                                        <available-funds-summary-row
                                            text="Ineligible Invoices"
                                            popoverText="Invoices that LSQ will not fund against. An invoice may become ineligible because it is: missing verification, past due, over credit limit, in dispute, etc."
                                            [signIcon]="icons.Add"
                                            [primaryValue]="
                                                (fundsOutstandingBalanceData$ | async)
                                                    .ineligibleBalance
                                            "
                                            [secondaryValue]="
                                                (fundsOutstandingBalanceData$ | async)
                                                    .ineligibleBalanceSubtotal
                                            "
                                        >
                                        </available-funds-summary-row>
                                        <available-funds-summary-row
                                            text="Accrued Collection Fees"
                                            popoverText="Collection Fees are the amount you pay for LSQ to track, collect, process and manage invoices and customer payments and are accrued on a daily basis."
                                            [signIcon]="icons.Add"
                                            [primaryValue]="
                                                (fundsOutstandingBalanceData$ | async)
                                                    .accruedCollectionFees
                                            "
                                            [secondaryValue]="
                                                (fundsOutstandingBalanceData$ | async)
                                                    .accruedCollectionFeesSubtotal
                                            "
                                        >
                                        </available-funds-summary-row>
                                        <available-funds-summary-row
                                            text="Accrued Funds Usage Daily Fee"
                                            popoverText="Fees incurred, month to date, based on your Funds Outstanding balance."
                                            [signIcon]="icons.Add"
                                            [primaryValue]="
                                                (fundsOutstandingBalanceData$ | async)
                                                    .accruedFundsOutstandingFees
                                            "
                                            [secondaryValue]="
                                                (fundsOutstandingBalanceData$ | async)
                                                    .accruedFundsOutstandingFeesSubtotal
                                            "
                                        >
                                        </available-funds-summary-row>
                                        <available-funds-summary-row
                                            text="Required Reserves"
                                            popoverText="The percentage of the eligible AR you are required to maintain based on your advance rate."
                                            [signIcon]="icons.Add"
                                            [primaryValue]="
                                                (fundsOutstandingBalanceData$ | async)
                                                    .requiredReserves
                                            "
                                            [secondaryValue]="
                                                (fundsOutstandingBalanceData$ | async)
                                                    .requiredReservesSubtotal
                                            "
                                        >
                                        </available-funds-summary-row>
                                    </div>
                                </available-funds-summary-expandable-container>

                                <available-funds-summary-row
                                    [isTotalRow]="true"
                                    text="Funds Outstanding Balance"
                                    [signIcon]="icons.EqualSign"
                                    popoverText="The outstanding balance of funds that LSQ has advanced to your account."
                                    [primaryValue]="
                                        (fundsOutstandingBalanceData$ | async).fundsOutstanding
                                    "
                                >
                                </available-funds-summary-row>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
